module.exports = __webpack_public_path__ + "img/error.5bc93119.png";